import axiosInstance from "./axiosInstance";

// Get documents for a specific employee
export const getDocuments = (companyId) => {
  return axiosInstance.get(
    `https://www.zapendhub.com/api/companies/${companyId}/documents/company_tax_documents`
  );
};

// Upload a document (example form data upload)
export const uploadDocument = (employeeId, formData) => {
  return axiosInstance.post(`/documents/upload/${employeeId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Delete a document`
export const deleteDocument = (documentId) => {
  return axiosInstance.delete(`/Documents/${documentId}`);
};
